const Address = require('./address.js');

class Location {
  constructor({
    /*: {
        id?: ?string;
        name?: string;
        address?: Address;
        policies?: ?Array<Object>;
        slug?: ?string;
        url?: ?string;
        phone?: ?string;
        enabled?: ?boolean;
        business?: ?Object;
        placeIds?: ?Object;
        tags?: ?Array<string>;
        socialProfiles?: Array<{ type: string, id: string }>
      }*/

    id,
    name,
    address,
    policies,
    slug,
    url,
    phone,
    enabled,
    business,
    placeIds,
    tags,
    socialProfiles
  } = {}) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.policies = policies;
    this.isEnabled = enabled;
    this.slug = slug;
    this.url = url;
    this.phone = phone;
    this.business = business;
    this.placeIds = placeIds;
    this.tags = tags;
    this.socialProfiles = socialProfiles;
  }

}

module.exports = Location;